/**
 * brand.js — Configuración de marca del frontend.
 *
 * Valores por defecto que se muestran ANTES de que
 * la API /api/site-config/public/ responda.
 *
 * En producción, SiteConfig (DB) sobrescribe estos valores.
 * Para clonar el proyecto: copiar .env.example → .env.local y completar VUE_APP_*.
 */

const brand = {
  // Identidad
  storeName: process.env.VUE_APP_STORE_NAME || 'godéa',
  storeSlogan: process.env.VUE_APP_STORE_SLOGAN || 'Tu tienda online',
  storeDescription:
    process.env.VUE_APP_STORE_DESCRIPTION ||
    'Tienda online con envíos a España mediante GLS.',
  storeLogoUrl: process.env.VUE_APP_STORE_LOGO_URL || '',
  storeLogoAltUrl: '',

  // Contacto (fallback si la API aún no respondió o no hay fila en BD)
  contactEmail: process.env.VUE_APP_CONTACT_EMAIL || 'contacto.godea@gmail.com',
  contactPhone: process.env.VUE_APP_CONTACT_PHONE || '',
  contactWhatsapp: process.env.VUE_APP_CONTACT_WHATSAPP || '',
  whatsappMessage:
    process.env.VUE_APP_WHATSAPP_MESSAGE || 'Hola, quisiera hacer una consulta',
  contactAddress: process.env.VUE_APP_CONTACT_ADDRESS || '',

  // Social
  socialInstagram: process.env.VUE_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/godea.es/',
  socialFacebook: process.env.VUE_APP_SOCIAL_FACEBOOK || '',
  socialTiktok: process.env.VUE_APP_SOCIAL_TIKTOK || '',
  socialTwitter: process.env.VUE_APP_SOCIAL_TWITTER || '',
  socialYoutube: process.env.VUE_APP_SOCIAL_YOUTUBE || '',

  // Branding
  primaryColor: process.env.VUE_APP_PRIMARY_COLOR || '#f1e0ab',
  secondaryColor: process.env.VUE_APP_SECONDARY_COLOR || '#c9b87a',
  accentColor: process.env.VUE_APP_ACCENT_COLOR || '#e8d090',

  // Comercial
  currency: 'EUR',
  currencySymbol: '€',
  paymentProvider: 'stripe',

  // Features
  enableBlog: false,
  enableDesktopApp: false,
  enableGuestCheckout: true,

  // SEO
  lang: process.env.VUE_APP_LANG || 'es',
  geoRegion: process.env.VUE_APP_GEO_REGION || 'ES',
  geoPlacename: process.env.VUE_APP_GEO_PLACENAME || '',

  // Developer
  developerName: process.env.VUE_APP_DEVELOPER_NAME || '',
  developerUrl: process.env.VUE_APP_DEVELOPER_URL || '',

  // Prefijo para claves de localStorage (evita colisiones entre clones)
  storagePrefix:
    process.env.VUE_APP_STORAGE_PREFIX ||
    (process.env.VUE_APP_STORE_NAME || 'store')
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, ''),
};

export default brand;
